import * as yup from 'yup';

export const schema:any = yup.object().shape({
  jobDescription: yup.string().nullable().trim()
    .required('The Job Description field is required.'),
  shortDescription: yup.string().max(100, 'You have 100 characters remaining').required('The Short Description field is required.').nullable(),
});
